import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ObjectHelper } from '@classes/object-helper';
import { JUNK_DESTINATION } from '@classes/trailer-helper';
import { Experience } from '@custom-types/experience.type';
import { GeoData } from '@models/geo-data.model';

@Component({
    selector: 'app-tow-locations',
    templateUrl: './tow-locations.component.html',
    styleUrls: ['./tow-locations.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TowLocationsComponent implements OnInit {
    @Input() driverAddress?: string;
    @Input() start!: GeoData;
    @Input() destination!: GeoData;
    @Input() experience: Experience = 'driver';
    @Input() isHome = false;
    @Input() driverAddressLabel?: string;
    @Input() isJunk: boolean | null;

    hideDestination = false;
    junkDestination = JUNK_DESTINATION;

    ngOnInit(): void {
        this.setDriverAddressLabel();
        this.hideDestination = ObjectHelper.areObjectsEqual(this.start, this.destination);
    }

    private setDriverAddressLabel(): void {
        if (this.experience === 'trailer') {
            this.driverAddressLabel = 'Driver Location';
            return;
        }

        const driverAddressLabel = this.driverAddressLabel ?? 'Current Location';
        this.driverAddressLabel = this.isHome ? 'Home' : driverAddressLabel;
    }
}
